module.exports = __webpack_public_path__ + "static/media/icon_system_social_pinterest.37349a6a.svg";